import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AnmarApiService } from '../anmar-api.service';
import { AnmarBaseFormComponent } from '../shared/anmar-base-form.component';
import { ANMAR_RESOURCES } from '../shared/anmar-resources';

@Component({ selector: 'app-anmar-services-form', templateUrl: '../blog/blog-form.component.html' })
export class AnmarServicesFormComponent extends AnmarBaseFormComponent {
  config = ANMAR_RESOURCES['services'];
  constructor(fb: FormBuilder, api: AnmarApiService, route: ActivatedRoute, router: Router, toastr: ToastrService) { super(fb, api, route, router, toastr); }
}
